const NS = 'ResourcesCustomCarouselBlock';
const CLS = 'resourcesCustomCarouselBlock';

import { handleTruncate } from '../../../../global/js/wlc/truncateNoReadMore';

export class ResourcesCustomCarouselBlock {
	constructor(element) {
		this.element = element;
		this.$element = $(element);
		this.$sliderContainer = this.$element.find(`.${CLS}-sliderContainer`);
		this.$themesCarousel = this.$element.find(`.${CLS}-carousel`);
		this.$carouselItems = this.$element.find(`.${CLS}-item`);
		this.$carouselSlider = this.$element.find(`.${CLS}-slider`);
		this.$videoModal = this.$element.find(`#videoModal`);
		this.$close = this.$element.find(`.close`);
		this.$modal = this.$element.find(`.modal`);
		this.$iframe = this.$element.find(`.modal iframe`);
		this.autoSlide = this.$element.data(`autoSlide`);
		this.description = this.$element.find(`.${CLS}-theme-desc`);
        $.each(this.description, function(i, val) {
            handleTruncate($(val), 450);
        });
		if(this.autoSlide === "False"){
			this.autoSlide = false;
		}
		else{
			this.autoSlide = true;
		}
		// init slider
		this.$carouselSlider.slick({
			arrows: true,
			//variableWidth: true,

			dots: true,
			dotsClass: `slick-dots`,
			autoplay: this.autoSlide,
  			autoplaySpeed: 5000,
			appendArrows: this.$sliderContainer,
			appendDots: this.$sliderContainer,
			nextArrow: `<button type="button" class="slick-arrow slick-arrow--next"><i class="slick-arrow-icon icon icon--chevron-lg-right"></i></button>`,
			prevArrow: `<button type="button" class="slick-arrow slick-arrow--previous"><i class="slick-arrow-icon icon icon--chevron-lg-left"></i></button>`,
			infinite: true,
			slidesToShow: 4,
			slidesToScroll: 3,
			cssEase: 'ease-in-out',
			responsive: [
				{
				  breakpoint: 1024,
				  settings: {
					slidesToShow: 2,
					slidesToScroll: 2,
					infinite: true,
					dots: true
				  }
				},
				{
				  breakpoint: 767,
				  settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				  }
				}
			  ]
		});

		const options = {
			arrows: true,
			infinite: false,
			dots: false,
			variableWidth: true,
			slidesToScroll: 3,
			prevArrow: "<button type='button' class='slick-prev pull-left'><</button>",
      		nextArrow: "<button type='button' class='slick-next pull-right'>></button>",
			  responsive: [
				{
				  breakpoint: 1024,
				  settings: {
					slidesToScroll: 2,
				  }
				},
				{
				  breakpoint: 600,
				  settings: {
					slidesToScroll: 1
				  }
				},
				{
				  breakpoint: 480,
				  settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				  }
				}
			  ]
		};

		this.$themesCarousel.slick(options);

		this.$videoModal.on('show.bs.modal', function (event) {
			var button = $(event.relatedTarget);
			var videosrc = button.data('videosrc');
			var modal = $(this);
			modal.find('.modal-body iframe').attr('src', videosrc);
		});
		$(this.$close).on('click', (e) => {
			e.preventDefault();
			$(this.$iframe).attr('src', '');
		});

		$(this.$modal).on('click', (e) => {
			e.preventDefault();
			$(this.$iframe).attr('src', '');
		});
	}
}

